import { Navigate, Outlet } from 'react-router-dom';
import { APP_PATHS } from '../../constants/paths';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { useChallengeStartTime } from '../../hooks/useChallengeStartTime/useChallengeStartTime';

export const PrivateRoute = () => {
  const { isSignedIn } = useAuth();
  const { isSignUpPeriod } = useChallengeStartTime();

  if (!isSignedIn && process.env.REACT_APP_LOCAL_DEV !== 'true') {
    return <Navigate to={APP_PATHS.login} />;
  }

  if (isSignUpPeriod && process.env.REACT_APP_LOCAL_DEV !== 'true') {
    return <Navigate to={APP_PATHS.signUp} />;
  }

  return <Outlet />;
};
